export default __webpack_public_path__ + "static/logo-460fbf801357d47bce93d0ac307b5dff.png";